module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "fm05"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Prologue")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_c('p', {
    staticClass: "chapterDateline",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("May 14th")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Devon Hiller lit a hand-rolled Cuban cigar and leaned back in his chair. Under strict doctor’s orders not to smoke, drink or become unduly stressed, he amused himself by blithely indulging in all three. Hell, he wasn’t dead yet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was good to have the house to himself again. A cleaning crew would come in the morning and pick up after the party, but for now he was just glad to be rid of that crowd of brown-nosers. And that included his niece, Elizabeth, though he had to admit issuing ultimatums to her had been the high point of his evening. Never mind her husband, a ticking bomb if there ever was one. What could "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he")]), _vm._v(" do about anything? Nothing, that’s what!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Devon took a generous sip of cognac, he thought he heard a noise in the foyer and straightened in his chair. Parking the cigar in a heavy crystal ashtray, he peered into the gloom as the door to his study silently drifted open.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who’s there?” he barked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A figure moved in the shadows.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page09"
    }
  }, [_vm._v("“That you, Elizabeth?” he chuckled as he set aside ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("the snifter. “Back again, are you? Changed your mind? Good, good. I knew you’d see it my way.”")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The figure stepped into the light. Not Elizabeth.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How did "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you")]), _vm._v(" get in here?” Devon demanded. The look on the intruder’s face caused an alarm to go off in Devon’s brandy soaked brain. His gun was in the wall safe. Palming the antique letter opener he always kept on his desk, he slowly got to his feet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I thought I made it clear I wasn’t going to do business with you,” he growled as he rounded his desk. A show of strength, that’s what was called for. Just as he decided to throw in a few words of warning, he finally noticed a long green cord stretched between the two gloved hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The intruder’s lips curled into a smile that sent Devon stumbling back, groping for the phone. His attacker moved swiftly, pulling Devon away from the desk, slamming him onto the Persian carpet. The impact caused the letter opener to tumble free.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Still Devon struggled, gratified as he felt his fingers wrap around the green fiber, then gasping as a sharp pain drove all other thoughts from his brain. He was conscious just long enough to glimpse the hilt of the letter opener erupting from his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He died knowing that, in the strictest sense, his bad habits had finally caught up with him.")])])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page10"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31faec46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459237445_fm05.vue
// module id = 84
// module chunks = 0